import React from 'react';
import styled, { css } from '../../styled';
import Text from '../text';
import tooltip from '../../themes/tooltip';
export const Content = styled.div ``;
export const TooltipWrapper = styled.div `
  display: ${({ show }) => (show ? 'block' : 'none')};
  z-index: ${({ theme }) => theme.zIndex.TootTip};
  position: absolute;
  top: ${({ theme, direction }) => theme.tooltip.directions[direction].tooltipTop};
  bottom: ${({ theme, direction }) => theme.tooltip.directions[direction].tooltipBottom};
  left: ${({ positionLeft }) => positionLeft};
  right: ${({ positionRight }) => positionRight};
  transform: ${({ positionTransform }) => positionTransform};
  box-sizing: border-box;
  padding: ${({ theme, direction, text }) => text ? theme.tooltip.directions[direction].padding : 0};
  background-color: ${({ theme, type }) => theme.colors[theme.tooltip.types[type].backgroundColor]};
  border-radius: 6px;
  text-align: ${({ theme, direction }) => theme.tooltip.directions[direction].textAlign};
  box-shadow: 0 1px 4px 0 ${({ theme }) => theme.colors.SHADOW_DARK},
    0 0 16px 0 ${({ theme }) => theme.colors.SHADOW_DEFAULT};

  > span {
    width: max-content;
    max-width: 9rem;
    white-space: pre-wrap;
    overflow-wrap: break-word;
    word-break: keep-all;
  }

  &:after {
    display: ${({ isArrowHide }) => (isArrowHide ? 'none' : 'block')};
    content: '';
    position: absolute;
    border-width: 0.3125rem;
    border-style: solid;
    top: ${({ theme, direction }) => theme.tooltip.directions[direction].arrowTop};
    bottom: ${({ theme, direction }) => theme.tooltip.directions[direction].arrowBottom};
    left: ${({ theme, direction }) => theme.tooltip.directions[direction].arrowLeft};
    right: ${({ theme, direction }) => theme.tooltip.directions[direction].arrowRight};
    transform: ${({ theme, direction }) => theme.tooltip.directions[direction].arrowTransform};
    border-top-color: ${({ theme, type, direction }) => theme.colors[theme.tooltip.directions[direction].arrowBorderColor(type, direction, 'TOP')]};
    border-right-color: ${({ theme, type, direction }) => theme.colors[theme.tooltip.directions[direction].arrowBorderColor(type, direction, 'RIGHT')]};
    border-bottom-color: ${({ theme, type, direction }) => theme.colors[theme.tooltip.directions[direction].arrowBorderColor(type, direction, 'BOTTOM')]};
    border-left-color: ${({ theme, type, direction }) => theme.colors[theme.tooltip.directions[direction].arrowBorderColor(type, direction, 'LEFT')]};
  }
  ${({ styles }) => 
// upgrade to @types/react 17.0.0
// @ts-ignore
styles && css({ ...styles })}
`;
const Container = styled.div `
  position: relative;
  display: inline-block;
  cursor: pointer;
`;
const TooltipView = ({ type, direction, text, lang = 'en', children, positionLeft = tooltip.directions[direction].tooltipLeft, positionRight = tooltip.directions[direction].tooltipRight, positionTransform = tooltip.directions[direction].tooltipTransform, show = false, overlay, isArrowHide = false, containerClassName, onClick, onMouseEnter, onMouseLeave, onMouseEnterChildren, onMouseLeaveChildren, e2eTooltipId, e2eContentId, }) => (React.createElement(Container, { onClick: onClick, show: show && (!!text || !!overlay), className: containerClassName },
    React.createElement(TooltipWrapper, { "data-e2e-id": e2eTooltipId, direction: direction, type: type, positionLeft: positionLeft, positionRight: positionRight, positionTransform: positionTransform, isArrowHide: isArrowHide, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, text: text, show: show && (!!text || !!overlay) },
        text && (React.createElement(Text, { fontType: "Caption", lang: lang, color: tooltip.types[type].textColor, weight: "Semibold" }, text)),
        !text && overlay && React.createElement(React.Fragment, null, overlay)),
    React.createElement(Content, { "data-e2e-id": e2eContentId, onMouseEnter: onMouseEnterChildren, onMouseLeave: onMouseLeaveChildren }, children)));
export default TooltipView;
//# sourceMappingURL=TooltipView.js.map